import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=5942c3a6&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports